import { render } from "./TokenVerify.vue?vue&type=template&id=2adf3ba8"
import script from "./TokenVerify.vue?vue&type=script&lang=js"
export * from "./TokenVerify.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__